export const ADD_HISTORY = 'ADD_HISTORY'

export const SET_HISTORY = 'SET_HISTORY'
export const FETCH_HISTORY_STARTED = 'FETCH_HISTORY_STARTED'
export const FETCH_HISTORY_ERROR = 'FETCH_HISTORY_ERROR'
